import { utilsQuery } from "@app/common";

const define = utilsQuery.defineQueryKeyCreator("analytics");

export const QueryKeys = {
    AnalyticsReport: define("analytics-report"),
} as const;
